import { Card, CardActions, CardContent, CardMedia, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

import TwoRunsImg from '../../assets/images/two_runs.png'


const TwoRuns = ({ openTwoRuns, setOpenTwoRuns }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={TwoRunsImg}
          title='2Runs'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>2Runs</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenTwoRuns(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openTwoRuns}
        onClose={() => setOpenTwoRuns(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          2Runs
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={TwoRunsImg} alt='minesweeper' style={{
              width: 700,
              maxWidth: '100%',
              objectFit: 'contain'
            }} />
          </div>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            2Runs is a game that I created in Lua programming language. You can check the code, read everything about the game and try the game on my <a href='https://github.com/farukdozo/2runs' target="_blank" rel='noreferrer'><strong style={{ color: '#D1C7F0', textDecoration: 'none' }}>GitHub</strong></a>.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Lua</li>
            </ul>
          </Typography>
          <Typography variant="h6" sx={{ color: '#EDEBF7', marginTop: '1rem' }}><strong>DEMO (Walkthrough)</strong>:</Typography>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row'
          }}>
            <iframe width="640" height="360" src="https://www.youtube.com/embed/aJbE7pswdaU" title="2runs Walkthrough" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenTwoRuns(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default TwoRuns